<template>
  <div
    class="relative flex flex-grow items-center justify-between rounded-md border-2 border-transparent bg-off-white p-0"
    :class="{ activeButton: show && checked }"
  >
    <div
      v-if="highlightBox"
      class="absolute right-0 top-0 rounded-bl-md rounded-tr-sm bg-yellow-500 px-2 py-1 text-xs font-semibold text-white"
    >
      {{ highlightText }}
    </div>
    <div class="inline-flex flex-grow">
      <label
        class="container"
        :class="{ 'text-dark-gray': show && checked }"
      >
        <slot />
        <section
          v-if="term === 'delta'"
          class="break-words"
        >
          <div class="mt-4 flex flex-col gap-2">
            <p class="font-normal">
              Get paid in minutes on loads for C.H. Robinson and other providers
              with
              <span class="font-bold text-neutral-subtle"
                >Factoring powered by Delta&#x2122;.</span
              >
            </p>
            <p class="italic text-neutral-subtlest">
              I’m opting into 2-Day Quick Pay until my factoring application is
              approved and assigned.
            </p>
          </div>
        </section>
        <section
          v-else-if="term === 'load_pay'"
          class="break-words"
        >
          <div class="flex flex-col gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="155"
              height="40"
              viewBox="0 0 155 40"
              fill="none"
            >
              <path
                d="M7.78125 13.592L7.78469 13.5805H5.1111C5.06056 13.584 4.91931 13.5908 4.71488 13.5908C4.4071 13.5908 3.95575 13.5748 3.46307 13.5036C2.20896 13.3221 1.59454 12.1116 1.103 11.4295L0.332386 13.6092C-0.920575 16.9684 1.52218 20.5413 5.08813 20.6343V20.6366H15.5425L16.8977 17.0994L18.223 13.6069L7.78125 13.592Z"
                fill="#3FB088"
              />
              <path
                d="M19.7431 12.6307L19.7397 12.6422H22.403C22.4523 12.6388 22.5948 12.6319 22.798 12.6319C23.1047 12.6319 23.5537 12.648 24.0441 12.7192C25.2925 12.9006 25.9046 14.1111 26.395 14.7933L27.1621 12.6135C28.4105 9.25428 25.9769 5.68145 22.4259 5.58842V5.58613H11.8131L10.4637 9.12336L9.14408 12.6158L19.7431 12.6307Z"
                fill="#1776DC"
              />
              <path
                d="M1.24763 12.6686C1.91718 13.6092 3.93501 13.6884 4.65509 13.6402H7.7318L12.7632 0H5.26607L1.04666 11.5351C0.972006 11.9944 1.03862 12.3746 1.24763 12.6686Z"
                fill="url(#paint0_linear_486_12135)"
              />
              <path
                d="M26.2472 13.5528C25.5777 12.6134 23.5598 12.5353 22.8397 12.5835H19.763L16.5095 20.7628H18.6846C21.9003 20.7628 24.7921 18.8082 25.9911 15.8245L26.4493 14.6841C26.524 14.2247 26.4574 13.8457 26.2483 13.5517L26.2472 13.5528Z"
                fill="url(#paint1_linear_486_12135)"
              />
              <path
                d="M5.20761 27.6203H13.1021L15.3668 21.5886H7.47236L5.20761 27.6203Z"
                fill="#1776DC"
              />
              <path
                d="M39.5521 19.5859H49.3243V23.8742H34.3312V3.45475H39.5532L39.5521 19.5859Z"
                fill="#211F1C"
              />
              <path
                d="M49.8791 16.4068C49.8791 11.5936 53.2337 8.61799 57.8425 8.61799C62.4512 8.61799 65.8058 11.5936 65.8058 16.4068C65.8058 21.22 62.4512 24.1657 57.8425 24.1657C53.2337 24.1657 49.8791 21.22 49.8791 16.4068ZM60.8181 16.4068C60.8181 14.0146 59.8259 12.6732 57.8425 12.6732C55.8591 12.6732 54.9254 14.0146 54.9254 16.4068C54.9254 18.799 55.9177 20.1117 57.8425 20.1117C59.7673 20.1117 60.8181 18.8277 60.8181 16.4068Z"
                fill="#211F1C"
              />
              <path
                d="M81.4122 14.4521V23.874H76.6576V21.6862C75.8112 23.4078 74.2654 24.1658 72.1362 24.1658C69.0147 24.1658 67.1485 22.4442 67.1485 20.0531C67.1485 16.9316 69.9783 15.2113 75.4334 15.2113H76.6588V14.219C76.6588 12.935 75.8124 12.3516 74.6169 12.3516C73.187 12.3516 72.4876 13.0809 72.4578 14.2764H67.5275C67.5275 10.3097 70.6777 8.61685 74.703 8.61685C78.9327 8.61685 81.4122 10.7185 81.4122 14.4521ZM76.6576 18.3316V17.6896H74.9074C72.9527 17.6896 72.1075 18.3603 72.1075 19.3526C72.1075 20.199 72.7782 20.6653 73.829 20.6653C75.4621 20.6653 76.6576 19.3813 76.6576 18.3316Z"
                fill="#211F1C"
              />
              <path
                d="M94.2461 3.45472H99.1178V23.8742H94.2461V21.5406C93.2837 23.2322 91.708 24.1659 89.6075 24.1659C85.8738 24.1659 83.423 21.2489 83.423 16.407C83.423 11.5651 85.8738 8.61817 89.6075 8.61817C91.708 8.61817 93.2825 9.55186 94.2461 11.2722V3.45472ZM94.4206 16.407C94.4206 14.0733 93.2825 12.6734 91.4163 12.6734C89.55 12.6734 88.4406 14.0733 88.4406 16.407C88.4406 18.7406 89.5202 20.1119 91.4163 20.1119C93.3124 20.1119 94.4206 18.7119 94.4206 16.407Z"
                fill="#211F1C"
              />
              <path
                d="M111.108 3.45472C116.476 3.45472 119.071 7.10106 119.071 10.6601C119.071 14.2192 116.474 17.9241 111.108 17.9241H107.17V23.8754H101.919V3.45472H111.108ZM110.67 13.723C112.625 13.723 113.82 12.5562 113.82 10.6601C113.82 8.76402 112.625 7.68447 110.67 7.68447H107.17V13.723H110.67Z"
                fill="#211F1C"
              />
              <path
                d="M134.007 14.4521V23.874H129.252V21.6862C128.406 23.4078 126.86 24.1658 124.731 24.1658C121.609 24.1658 119.743 22.4442 119.743 20.0531C119.743 16.9316 122.573 15.2113 128.028 15.2113H129.253V14.219C129.253 12.935 128.407 12.3516 127.211 12.3516C125.782 12.3516 125.082 13.0809 125.052 14.2764H120.122C120.122 10.3097 123.272 8.61685 127.298 8.61685C131.527 8.61685 134.007 10.7185 134.007 14.4521ZM129.252 18.3316V17.6896H127.502C125.547 17.6896 124.702 18.3603 124.702 19.3526C124.702 20.199 125.373 20.6653 126.424 20.6653C128.057 20.6653 129.252 19.3813 129.252 18.3316Z"
                fill="#211F1C"
              />
              <path
                d="M146.374 8.90981H151.392L145.704 24.6034C144.449 28.1039 141.853 30 138.848 30C137.74 30 136.544 29.7083 135.348 29.1536V25.1283C136.31 25.5945 137.361 25.9161 138.324 25.9161C139.462 25.9161 140.366 25.4498 140.862 24.2531L140.89 24.1946L134.502 8.90981H139.84L143.34 18.2157L146.374 8.90981Z"
                fill="#211F1C"
              />
              <path
                d="M35.4041 36.2264H34.5985L36.9286 29.8807H37.7218L40.0518 36.2264H39.2462L37.35 30.8846H37.3004L35.4041 36.2264ZM35.7016 33.7476H38.9488V34.4293H35.7016V33.7476Z"
                fill="#6B645D"
              />
              <path
                d="M45.1921 36.3255C44.7955 36.3255 44.4454 36.2253 44.1418 36.025C43.8381 35.8225 43.6006 35.5375 43.4291 35.1698C43.2577 34.8001 43.172 34.3632 43.172 33.8592C43.172 33.3593 43.2577 32.9255 43.4291 32.5578C43.6006 32.1901 43.8392 31.9061 44.1449 31.7057C44.4506 31.5054 44.8038 31.4052 45.2045 31.4052C45.5144 31.4052 45.7592 31.4568 45.9389 31.5601C46.1206 31.6613 46.259 31.777 46.3541 31.9071C46.4512 32.0352 46.5266 32.1406 46.5803 32.2232H46.6422V29.8807H47.3735V36.2264H46.667V35.4951H46.5803C46.5266 35.5819 46.4501 35.6914 46.351 35.8236C46.2518 35.9537 46.1103 36.0704 45.9265 36.1737C45.7426 36.2749 45.4979 36.3255 45.1921 36.3255ZM45.2913 35.6687C45.5846 35.6687 45.8325 35.5922 46.0349 35.4394C46.2374 35.2845 46.3913 35.0707 46.4966 34.798C46.6019 34.5233 46.6546 34.2062 46.6546 33.8468C46.6546 33.4915 46.603 33.1806 46.4997 32.9141C46.3964 32.6456 46.2436 32.437 46.0411 32.2882C45.8387 32.1375 45.5888 32.0621 45.2913 32.0621C44.9815 32.0621 44.7233 32.1416 44.5167 32.3006C44.3122 32.4576 44.1583 32.6714 44.055 32.942C43.9538 33.2106 43.9032 33.5121 43.9032 33.8468C43.9032 34.1855 43.9548 34.4933 44.0581 34.7701C44.1635 35.0448 44.3184 35.2638 44.5229 35.427C44.7294 35.5881 44.9856 35.6687 45.2913 35.6687Z"
                fill="#6B645D"
              />
              <path
                d="M48.8142 36.2264V31.4672H49.5455V36.2264H48.8142ZM49.1861 30.674C49.0435 30.674 48.9206 30.6254 48.8173 30.5283C48.7161 30.4312 48.6655 30.3145 48.6655 30.1782C48.6655 30.0419 48.7161 29.9252 48.8173 29.8281C48.9206 29.731 49.0435 29.6824 49.1861 29.6824C49.3286 29.6824 49.4505 29.731 49.5517 29.8281C49.655 29.9252 49.7066 30.0419 49.7066 30.1782C49.7066 30.3145 49.655 30.4312 49.5517 30.5283C49.4505 30.6254 49.3286 30.674 49.1861 30.674Z"
                fill="#6B645D"
              />
              <path
                d="M54.7764 31.4672L53.0165 36.2264H52.2729L50.513 31.4672H51.3062L52.6199 35.2597H52.6695L53.9832 31.4672H54.7764Z"
                fill="#6B645D"
              />
              <path
                d="M55.7416 36.2264V31.4672H56.4728V36.2264H55.7416ZM56.1134 30.674C55.9709 30.674 55.848 30.6254 55.7447 30.5283C55.6435 30.4312 55.5929 30.3145 55.5929 30.1782C55.5929 30.0419 55.6435 29.9252 55.7447 29.8281C55.848 29.731 55.9709 29.6824 56.1134 29.6824C56.2559 29.6824 56.3778 29.731 56.479 29.8281C56.5823 29.9252 56.634 30.0419 56.634 30.1782C56.634 30.3145 56.5823 30.4312 56.479 30.5283C56.3778 30.6254 56.2559 30.674 56.1134 30.674Z"
                fill="#6B645D"
              />
              <path
                d="M61.1833 32.533L60.5264 32.7189C60.4851 32.6095 60.4241 32.5031 60.3436 32.3998C60.2651 32.2944 60.1577 32.2077 60.0213 32.1395C59.885 32.0714 59.7105 32.0373 59.4977 32.0373C59.2065 32.0373 58.9637 32.1044 58.7696 32.2387C58.5775 32.3709 58.4814 32.5392 58.4814 32.7437C58.4814 32.9255 58.5475 33.0691 58.6797 33.1744C58.8119 33.2798 59.0185 33.3675 59.2994 33.4378L60.0059 33.6113C60.4314 33.7146 60.7484 33.8726 60.9571 34.0854C61.1657 34.296 61.27 34.5677 61.27 34.9002C61.27 35.1729 61.1915 35.4167 61.0345 35.6315C60.8796 35.8463 60.6627 36.0157 60.3839 36.1396C60.105 36.2636 59.7807 36.3255 59.4109 36.3255C58.9255 36.3255 58.5238 36.2202 58.2056 36.0095C57.8875 35.7988 57.6861 35.491 57.6015 35.0862L58.2955 34.9126C58.3616 35.1688 58.4866 35.3609 58.6704 35.4889C58.8563 35.617 59.099 35.6811 59.3986 35.6811C59.7394 35.6811 60.01 35.6088 60.2103 35.4642C60.4128 35.3175 60.514 35.1419 60.514 34.9374C60.514 34.7722 60.4562 34.6338 60.3405 34.5222C60.2248 34.4086 60.0472 34.3239 59.8075 34.2682L59.0143 34.0823C58.5785 33.979 58.2583 33.8189 58.0538 33.602C57.8514 33.383 57.7502 33.1093 57.7502 32.7809C57.7502 32.5124 57.8256 32.2748 57.9764 32.0683C58.1292 31.8617 58.3368 31.6995 58.5992 31.5818C58.8636 31.4641 59.1631 31.4052 59.4977 31.4052C59.9687 31.4052 60.3384 31.5085 60.607 31.715C60.8775 31.9216 61.0697 32.1943 61.1833 32.533Z"
                fill="#6B645D"
              />
              <path
                d="M62.3707 36.2264V31.4672H63.102V36.2264H62.3707ZM62.7426 30.674C62.6 30.674 62.4771 30.6254 62.3738 30.5283C62.2726 30.4312 62.222 30.3145 62.222 30.1782C62.222 30.0419 62.2726 29.9252 62.3738 29.8281C62.4771 29.731 62.6 29.6824 62.7426 29.6824C62.8851 29.6824 63.007 29.731 63.1082 29.8281C63.2115 29.9252 63.2631 30.0419 63.2631 30.1782C63.2631 30.3145 63.2115 30.4312 63.1082 30.5283C63.007 30.6254 62.8851 30.674 62.7426 30.674Z"
                fill="#6B645D"
              />
              <path
                d="M66.3747 36.3255C65.9451 36.3255 65.5681 36.2233 65.2438 36.0188C64.9215 35.8143 64.6695 35.5282 64.4878 35.1605C64.3081 34.7928 64.2182 34.3632 64.2182 33.8716C64.2182 33.3758 64.3081 32.9431 64.4878 32.5733C64.6695 32.2036 64.9215 31.9164 65.2438 31.7119C65.5681 31.5074 65.9451 31.4052 66.3747 31.4052C66.8044 31.4052 67.1803 31.5074 67.5026 31.7119C67.8269 31.9164 68.0789 32.2036 68.2586 32.5733C68.4404 32.9431 68.5312 33.3758 68.5312 33.8716C68.5312 34.3632 68.4404 34.7928 68.2586 35.1605C68.0789 35.5282 67.8269 35.8143 67.5026 36.0188C67.1803 36.2233 66.8044 36.3255 66.3747 36.3255ZM66.3747 35.6687C66.7011 35.6687 66.9696 35.585 67.1803 35.4177C67.391 35.2504 67.547 35.0304 67.6482 34.7577C67.7494 34.4851 67.8 34.1897 67.8 33.8716C67.8 33.5534 67.7494 33.257 67.6482 32.9823C67.547 32.7076 67.391 32.4855 67.1803 32.3161C66.9696 32.1468 66.7011 32.0621 66.3747 32.0621C66.0483 32.0621 65.7798 32.1468 65.5691 32.3161C65.3584 32.4855 65.2025 32.7076 65.1013 32.9823C65 33.257 64.9494 33.5534 64.9494 33.8716C64.9494 34.1897 65 34.4851 65.1013 34.7577C65.2025 35.0304 65.3584 35.2504 65.5691 35.4177C65.7798 35.585 66.0483 35.6687 66.3747 35.6687Z"
                fill="#6B645D"
              />
              <path
                d="M70.3787 33.3634V36.2264H69.6475V31.4672H70.3539V32.2108H70.4159C70.5274 31.9691 70.6968 31.7749 70.924 31.6283C71.1512 31.4796 71.4446 31.4052 71.804 31.4052C72.1262 31.4052 72.4082 31.4713 72.6499 31.6035C72.8915 31.7336 73.0795 31.9319 73.2138 32.1984C73.348 32.4628 73.4152 32.7974 73.4152 33.2023V36.2264H72.6839V33.2519C72.6839 32.878 72.5869 32.5867 72.3927 32.3781C72.1985 32.1674 71.9321 32.0621 71.5933 32.0621C71.3599 32.0621 71.1512 32.1127 70.9674 32.2139C70.7856 32.3151 70.6421 32.4628 70.5367 32.657C70.4314 32.8511 70.3787 33.0866 70.3787 33.3634Z"
                fill="#6B645D"
              />
              <path
                d="M79.1388 36.3255C78.7091 36.3255 78.3322 36.2233 78.0079 36.0188C77.6856 35.8143 77.4336 35.5282 77.2518 35.1605C77.0721 34.7928 76.9823 34.3632 76.9823 33.8716C76.9823 33.3758 77.0721 32.9431 77.2518 32.5733C77.4336 32.2036 77.6856 31.9164 78.0079 31.7119C78.3322 31.5074 78.7091 31.4052 79.1388 31.4052C79.5684 31.4052 79.9444 31.5074 80.2666 31.7119C80.5909 31.9164 80.8429 32.2036 81.0227 32.5733C81.2044 32.9431 81.2953 33.3758 81.2953 33.8716C81.2953 34.3632 81.2044 34.7928 81.0227 35.1605C80.8429 35.5282 80.5909 35.8143 80.2666 36.0188C79.9444 36.2233 79.5684 36.3255 79.1388 36.3255ZM79.1388 35.6687C79.4652 35.6687 79.7337 35.585 79.9444 35.4177C80.1551 35.2504 80.311 35.0304 80.4123 34.7577C80.5135 34.4851 80.5641 34.1897 80.5641 33.8716C80.5641 33.5534 80.5135 33.257 80.4123 32.9823C80.311 32.7076 80.1551 32.4855 79.9444 32.3161C79.7337 32.1468 79.4652 32.0621 79.1388 32.0621C78.8124 32.0621 78.5439 32.1468 78.3332 32.3161C78.1225 32.4855 77.9665 32.7076 77.8653 32.9823C77.7641 33.257 77.7135 33.5534 77.7135 33.8716C77.7135 34.1897 77.7641 34.4851 77.8653 34.7577C77.9665 35.0304 78.1225 35.2504 78.3332 35.4177C78.5439 35.585 78.8124 35.6687 79.1388 35.6687Z"
                fill="#6B645D"
              />
              <path
                d="M84.5309 31.4672V32.0868H81.9654V31.4672H84.5309ZM82.7338 36.2264V30.8103C82.7338 30.5376 82.7978 30.3104 82.9259 30.1286C83.054 29.9468 83.2202 29.8105 83.4247 29.7196C83.6292 29.6287 83.8451 29.5833 84.0723 29.5833C84.252 29.5833 84.3987 29.5978 84.5123 29.6267C84.6259 29.6556 84.7106 29.6824 84.7664 29.7072L84.5557 30.3393C84.5185 30.3269 84.4668 30.3114 84.4007 30.2928C84.3367 30.2743 84.252 30.265 84.1467 30.265C83.905 30.265 83.7304 30.3259 83.623 30.4478C83.5177 30.5696 83.465 30.7483 83.465 30.9838V36.2264H82.7338Z"
                fill="#6B645D"
              />
              <path
                d="M87.7618 30.5624V29.8807H92.521V30.5624H90.5256V36.2264H89.7572V30.5624H87.7618Z"
                fill="#6B645D"
              />
              <path
                d="M93.7069 36.2264V29.8807H95.9254C96.3675 29.8807 96.7321 29.9572 97.0192 30.11C97.3063 30.2608 97.5201 30.4643 97.6606 30.7204C97.801 30.9745 97.8713 31.2565 97.8713 31.5663C97.8713 31.839 97.8227 32.0641 97.7256 32.2418C97.6306 32.4194 97.5046 32.5599 97.3476 32.6632C97.1927 32.7664 97.0244 32.8429 96.8426 32.8924V32.9544C97.0368 32.9668 97.232 33.035 97.4282 33.1589C97.6244 33.2829 97.7886 33.4605 97.9208 33.6918C98.053 33.9232 98.1191 34.2062 98.1191 34.5408C98.1191 34.8589 98.0468 35.145 97.9023 35.3991C97.7577 35.6532 97.5294 35.8546 97.2175 36.0033C96.9056 36.152 96.4997 36.2264 95.9998 36.2264H93.7069ZM94.4754 35.5447H95.9998C96.5018 35.5447 96.8581 35.4476 97.0688 35.2535C97.2815 35.0572 97.3879 34.8197 97.3879 34.5408C97.3879 34.326 97.3332 34.1277 97.2237 33.9459C97.1142 33.7621 96.9583 33.6154 96.7558 33.5059C96.5534 33.3944 96.3138 33.3386 96.037 33.3386H94.4754V35.5447ZM94.4754 32.6694H95.9007C96.132 32.6694 96.3406 32.6239 96.5265 32.533C96.7145 32.4421 96.8632 32.3141 96.9727 32.1488C97.0843 31.9836 97.14 31.7894 97.14 31.5663C97.14 31.2874 97.0429 31.0509 96.8488 30.8568C96.6546 30.6605 96.3468 30.5624 95.9254 30.5624H94.4754V32.6694Z"
                fill="#6B645D"
              />
              <path
                d="M99.3818 36.2264V29.8807H100.15V33.0288H100.225L103.075 29.8807H104.079L101.414 32.7437L104.079 36.2264H103.149L100.943 33.2767L100.15 34.169V36.2264H99.3818Z"
                fill="#6B645D"
              />
              <path
                d="M106.065 35.3588L106.016 35.6934C105.98 35.9289 105.927 36.1809 105.854 36.4495C105.784 36.718 105.711 36.971 105.634 37.2086C105.558 37.4461 105.495 37.6351 105.445 37.7756H104.888C104.915 37.6434 104.95 37.4689 104.993 37.252C105.036 37.0351 105.08 36.7924 105.123 36.5238C105.169 36.2574 105.206 35.9847 105.235 35.7058L105.272 35.3588H106.065Z"
                fill="#6B645D"
              />
              <path
                d="M113.443 31.4672C113.406 31.1532 113.255 30.9094 112.991 30.7359C112.727 30.5624 112.402 30.4757 112.018 30.4757C111.737 30.4757 111.491 30.5211 111.281 30.612C111.072 30.7029 110.909 30.8278 110.791 30.9869C110.675 31.146 110.618 31.3267 110.618 31.5291C110.618 31.6985 110.658 31.8441 110.738 31.966C110.821 32.0858 110.926 32.186 111.054 32.2666C111.182 32.3451 111.317 32.4101 111.457 32.4618C111.598 32.5113 111.727 32.5516 111.845 32.5826L112.489 32.7561C112.654 32.7995 112.838 32.8594 113.041 32.9358C113.245 33.0122 113.44 33.1166 113.626 33.2488C113.814 33.3789 113.969 33.5462 114.091 33.7507C114.213 33.9552 114.274 34.2062 114.274 34.5036C114.274 34.8465 114.184 35.1564 114.004 35.4332C113.826 35.71 113.566 35.93 113.223 36.0931C112.882 36.2563 112.468 36.3379 111.981 36.3379C111.526 36.3379 111.133 36.2646 110.8 36.1179C110.47 35.9713 110.21 35.7668 110.02 35.5044C109.832 35.2421 109.725 34.9374 109.7 34.5904H110.494C110.514 34.83 110.595 35.0283 110.735 35.1853C110.878 35.3402 111.058 35.4559 111.274 35.5323C111.493 35.6067 111.729 35.6439 111.981 35.6439C112.274 35.6439 112.538 35.5964 112.771 35.5013C113.004 35.4043 113.189 35.27 113.326 35.0985C113.462 34.925 113.53 34.7226 113.53 34.4912C113.53 34.2806 113.471 34.1091 113.353 33.9769C113.236 33.8447 113.081 33.7373 112.889 33.6547C112.697 33.572 112.489 33.4997 112.266 33.4378L111.485 33.2147C110.989 33.0722 110.597 32.8687 110.308 32.6043C110.018 32.3399 109.874 31.9939 109.874 31.5663C109.874 31.211 109.97 30.9012 110.162 30.6368C110.356 30.3703 110.616 30.1637 110.943 30.0171C111.271 29.8684 111.638 29.794 112.043 29.794C112.452 29.794 112.815 29.8673 113.133 30.014C113.452 30.1586 113.704 30.3569 113.889 30.6089C114.077 30.8609 114.177 31.147 114.187 31.4672H113.443Z"
                fill="#6B645D"
              />
              <path
                d="M119.007 31.4672C118.97 31.1532 118.819 30.9094 118.555 30.7359C118.291 30.5624 117.966 30.4757 117.582 30.4757C117.301 30.4757 117.055 30.5211 116.845 30.612C116.636 30.7029 116.473 30.8278 116.355 30.9869C116.239 31.146 116.182 31.3267 116.182 31.5291C116.182 31.6985 116.222 31.8441 116.302 31.966C116.385 32.0858 116.49 32.186 116.618 32.2666C116.747 32.3451 116.881 32.4101 117.021 32.4618C117.162 32.5113 117.291 32.5516 117.409 32.5826L118.053 32.7561C118.218 32.7995 118.402 32.8594 118.605 32.9358C118.809 33.0122 119.004 33.1166 119.19 33.2488C119.378 33.3789 119.533 33.5462 119.655 33.7507C119.777 33.9552 119.838 34.2062 119.838 34.5036C119.838 34.8465 119.748 35.1564 119.568 35.4332C119.391 35.71 119.13 35.93 118.787 36.0931C118.447 36.2563 118.032 36.3379 117.545 36.3379C117.09 36.3379 116.697 36.2646 116.364 36.1179C116.034 35.9713 115.774 35.7668 115.584 35.5044C115.396 35.2421 115.289 34.9374 115.264 34.5904H116.058C116.078 34.83 116.159 35.0283 116.299 35.1853C116.442 35.3402 116.622 35.4559 116.838 35.5323C117.057 35.6067 117.293 35.6439 117.545 35.6439C117.838 35.6439 118.102 35.5964 118.335 35.5013C118.568 35.4043 118.753 35.27 118.89 35.0985C119.026 34.925 119.094 34.7226 119.094 34.4912C119.094 34.2806 119.035 34.1091 118.918 33.9769C118.8 33.8447 118.645 33.7373 118.453 33.6547C118.261 33.572 118.053 33.4997 117.83 33.4378L117.049 33.2147C116.553 33.0722 116.161 32.8687 115.872 32.6043C115.583 32.3399 115.438 31.9939 115.438 31.5663C115.438 31.211 115.534 30.9012 115.726 30.6368C115.92 30.3703 116.181 30.1637 116.507 30.0171C116.835 29.8684 117.202 29.794 117.607 29.794C118.016 29.794 118.379 29.8673 118.698 30.014C119.016 30.1586 119.268 30.3569 119.454 30.6089C119.642 30.8609 119.741 31.147 119.751 31.4672H119.007Z"
                fill="#6B645D"
              />
              <path
                d="M121.101 36.2264V29.8807H123.32C123.762 29.8807 124.126 29.9572 124.413 30.11C124.701 30.2608 124.914 30.4643 125.055 30.7204C125.195 30.9745 125.265 31.2565 125.265 31.5663C125.265 31.839 125.217 32.0641 125.12 32.2418C125.025 32.4194 124.899 32.5599 124.742 32.6632C124.587 32.7664 124.419 32.8429 124.237 32.8924V32.9544C124.431 32.9668 124.626 33.035 124.822 33.1589C125.019 33.2829 125.183 33.4605 125.315 33.6918C125.447 33.9232 125.513 34.2062 125.513 34.5408C125.513 34.8589 125.441 35.145 125.296 35.3991C125.152 35.6532 124.924 35.8546 124.612 36.0033C124.3 36.152 123.894 36.2264 123.394 36.2264H121.101ZM121.87 35.5447H123.394C123.896 35.5447 124.252 35.4476 124.463 35.2535C124.676 35.0572 124.782 34.8197 124.782 34.5408C124.782 34.326 124.727 34.1277 124.618 33.9459C124.508 33.7621 124.352 33.6154 124.15 33.5059C123.948 33.3944 123.708 33.3386 123.431 33.3386H121.87V35.5447ZM121.87 32.6694H123.295C123.526 32.6694 123.735 32.6239 123.921 32.533C124.109 32.4421 124.257 32.3141 124.367 32.1488C124.478 31.9836 124.534 31.7894 124.534 31.5663C124.534 31.2874 124.437 31.0509 124.243 30.8568C124.049 30.6605 123.741 30.5624 123.32 30.5624H121.87V32.6694Z"
                fill="#6B645D"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_486_12135"
                  x1="75.694"
                  y1="9.26723"
                  x2="75.694"
                  y2="32.3622"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.22"
                    stop-color="#3FB088"
                  />
                  <stop
                    offset="1"
                    stop-color="#1B7960"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_486_12135"
                  x1="75.6894"
                  y1="42.3682"
                  x2="75.6894"
                  y2="6.69773"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#1776DC" />
                  <stop
                    offset="1"
                    stop-color="#1B538F"
                  />
                </linearGradient>
              </defs>
            </svg>
            <p class="font-normal">
              Get paid in minutes and manage cashflow all in one friendly and
              easy to use digital bank account.
            </p>
          </div>
        </section>
        <div
          v-else
          class="flex w-full justify-between"
        >
          <div class="flex flex-col justify-center">
            <p
              class="text-1md"
              :class="{ 'text-dark-gray': checked, [customClass]: customClass }"
            >
              {{ item }}
            </p>
            <p
              v-if="!!subtext.length"
              class="text-xxs leading-3"
              :class="
                checked
                  ? `text-dark-gray ${subtextClass}`
                  : `text-body-color ${subtextClass}`
              "
              style="margin-top: 3px; margin-bottom: 3px"
              v-html="subtext"
            />
          </div>
          <div
            v-if="apm?.length > 0"
            class="flex items-center"
          >
            <div
              class="flex-row-at-400px items-center-at-400px relative flex justify-center gap-1"
              style="top: -1.5px"
            >
              <div
                v-for="m in formatAPM"
                :key="m"
                class=""
              >
                <span
                  class="rounded-md border px-1 py-0.5 text-2xs uppercase leading-none"
                  :class="[
                    checked
                      ? 'border-light-gray bg-light-gray text-dark-gray'
                      : 'border-gray-over-dark text-gray-over-dark',
                  ]"
                >
                  {{ formatAllowedPaymentMethod(m) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <input
          type="radio"
          :value="value"
          :name="name"
          :checked="show && checked"
          :disabled="disabled"
          @click="handleClick"
        />
        <span class="checkmark" />
      </label>
    </div>
    <div
      v-if="term === 'quick_pay' || term === 'ach_deposit'"
      class="relative mr-3 flex items-center justify-center gap-1"
      style="top: -3px"
    >
      <div>
        <span
          class="text-xxs leading-3"
          :class="[checked ? 'text-dark-gray' : 'text-body-color']"
        >
          Terms
        </span>
      </div>
      <div class="margin-top-tooltip">
        <info-tooltip
          color-scheme="dark"
          content="'1'"
          class="relative"
          style="top: 1.5px"
        >
          <div>
            <p class="text-xxs">
              {{ getTextByTerm(term) }}
            </p>
          </div>
        </info-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTooltip from '@/components/InfoTooltip.vue';
export default {
  name: 'RoundRadioButtonTerms',
  components: { InfoTooltip },
  props: {
    item: String,
    name: String,
    term: String,
    checked: Boolean,
    subtext: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    subtextClass: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
    value: [String, Boolean, Number],
    handleClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    apm: {
      type: [Array, Boolean],
      default: false,
    },
    highlightBox: {
      type: Boolean,
      default: false,
    },
    highlightText: {
      type: String,
      default: '',
    },
  },
  computed: {
    formatAPM() {
      if (
        !this.$store.getters['shouldEnableCHRFlow'] ||
        this.$store.getters['isForeignCarrier']
      ) {
        return this.apm.filter((m) => m !== 'load_pay');
      }
      return this.apm;
    },
  },
  methods: {
    formatAllowedPaymentMethod(apm) {
      if (apm == 'load_pay') return 'LoadPay';

      return apm?.replace(/_/g, ' ');
    },
    getTextByTerm(term) {
      const carrier = this.$store.state.carriers?.carrierDetails?.legal_name;
      const broker = this.$store.state.brokers?.logo.legal_name;
      switch (term) {
        case 'ach_deposit':
          return `${carrier} authorizes ${broker} to initiate electronic payment through the ACH system to the deposit account provided by ${carrier}.`;
        case 'quick_pay':
          return `By choosing Quick Pay, ${carrier} agrees to the terms of ${broker}'s Quick Pay program including early payment for a discount.`;
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.container {
  @apply relative block flex h-full cursor-pointer items-center pl-12 text-left text-sm text-body-color;
  min-height: 60px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  @apply absolute left-2 top-2/4 h-6 w-6 rounded-full bg-white;
  transform: translate(0, -50%);
}

/* When the checkbox is checked, add a yellow background */
.container input:checked ~ .checkmark {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 8px;
  width: 8px;
  height: 8px;
  background-color: white;
  border: solid white;
  border-radius: 9999px;
}

.activeButton {
  @apply rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}
.margin-top-tooltip {
  margin-top: 10px;
}

.flex-at-400px {
  @apply hidden;
}
.flex-row-at-400px {
  @apply flex-col;
}
.items-center-at-400px {
  @apply items-start;
}

@media (min-width: 400px) {
  .flex-at-400px {
    @apply flex;
  }
  .flex-row-at-400px {
    @apply flex-row;
  }
  .items-center-at-400px {
    @apply items-center;
  }
}
</style>
